(function () {
  const annotate = RoughNotation.annotate;
  // const annotationGroup = RoughNotation.annotationGroup;
  // const $ = (t) => document.querySelector(t);

  // export interface RoughAnnotationConfig {
  //   type: RoughAnnotationType;
  //   animate?: boolean; // defaults to true
  //   animationDuration?: number; // defaulst to 1000ms
  //   animationDelay?: number; // default = 0
  //   color?: string; // defaults to currentColor
  //   strokeWidth?: number; // default based on type
  //   padding?: number; // defaults to 5px
  // }

  {

    const Highlights = document.querySelectorAll('.rough');

    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          // console.log('in the view');
          const rough = annotate(entry.target, { type: 'highlight', color: 'currentColor', animationDuration: 1500, multiline: true, iterations: 3 });
          setTimeout(function(){ rough.show() }, 1000);
          observer.unobserve(entry.target);

        } else {
          // console.log('out of view');
        }
      });
    });

    Highlights.forEach(highlight => {
      observer.observe(highlight);
    });

  }

})();